module.exports = __webpack_public_path__ + "img/Thumbnails_Introduction.ff84b501.jpg";